import React, { useEffect, useState } from 'react';
import SliderSlick from 'react-slick';
import { FiMapPin } from 'react-icons/fi';

import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Container,
  Hero,
  Services,
  SpeedConsultation,
  SpecialTreatments,
  Location,
  Testimonials,
  DrIvaniHero,
} from './styles';

import logo from '~/assets/logos/full-logo.svg';
import draIvani from '~/assets/defaults/dra-ivani-welcome.png';
import draIvaniHero from '~/assets/defaults/dra-ivani.png';
import xRay from '~/assets/defaults/x-ray.png';
import sterilizationCenter from '~/assets/defaults/sterilization-center.png';
import technologicalTreatments from '~/assets/defaults/technological-treatments.png';
import personalizedTreatments from '~/assets/defaults/personalized-treatments.png';
import coiExpirience from '~/assets/defaults/coi-expirience.png';
import coiExpirienceLaptop from '~/assets/defaults/coi-expirience-laptop.png';
import coiExpirienceMobile from '~/assets/defaults/coi-expirience-mobile.png';
import checkUp from '~/assets/defaults/check-up.png';
import checkUpLaptop from '~/assets/defaults/check-up-laptop.png';
import checkUpMobile from '~/assets/defaults/check-up-mobile.png';
import stamp from '~/assets/defaults/stamp.png';
import locationBig from '~/assets/defaults/location-big.png';
import locationMobile from '~/assets/defaults/location.png';
import InstagramPost from '~/components/InstagramEmbed';
import Reviews from '~/components/Reviews';
import whatsAppSVG from '~/assets/icons/whatsapp.svg';

const SITE_URL = 'https://coiprime.com.br';
const PAGE_URL = `${SITE_URL}/implantes`;
const BUSINESS_ID = `${SITE_URL}/#organization`;
const PHONE_E164 = '+551141981987';
const PHONE_LABEL = '(11) 4198-1987';
const STREET_ADDRESS = 'Av. Trindade, 165 - Bethaville I';
const POSTAL_CODE = '06404-326';
const MAPS_LINK = 'https://maps.app.goo.gl/LPv5rTrzvAVKhsVSA';
const PAGE_TITLE = 'Implantes Dentários em Bethaville, Barueri | COI Prime';
const PAGE_DESCRIPTION =
  'Implante dentário em Bethaville, Barueri com especialista em Implantodontia, planejamento digital 3D e mais de 30 anos de experiência. COI Prime, Av. Trindade, 165.';

// Perguntas diretas (AEO): mesmo conteúdo renderizado na página e no JSON-LD
const FAQS: { question: string; answer: string }[] = [
  {
    question: 'Onde fazer implante dentário no Bethaville, Barueri?',
    answer: `A COI Prime faz implante dentário no Bethaville, em Barueri, na ${STREET_ADDRESS}. O atendimento é com a Dra. Ivani (CROSP 66115), especialista em Implantodontia, com avaliação por RX panorâmico e escaneamento 3D na própria clínica.`,
  },
  {
    question: 'Quem é o especialista em implante no Bethaville?',
    answer:
      'Na COI Prime, os implantes são conduzidos pela Dra. Ivani (CROSP 66115), especialista em Implantodontia, com mais de 30 anos de experiência em implantes dentários.',
  },
  {
    question: 'Quanto tempo demora o tratamento de implante?',
    answer:
      'O prazo varia em cada caso. A cirurgia de instalação costuma ser rápida e a cicatrização do osso leva, em geral, alguns meses até a prótese definitiva. O prazo exato é definido na avaliação, com planejamento digital.',
  },
  {
    question: 'Como é feito o tratamento de implante dentário na COI Prime?',
    answer:
      'São cinco etapas: avaliação com RX panorâmico e escaneamento 3D, planejamento digital, cirurgia para instalação dos implantes, confecção e instalação da prótese estética e funcional, e acompanhamento pós-cirúrgico.',
  },
  {
    question: 'O implante dentário dói?',
    answer:
      'A cirurgia é feita com anestesia e a COI Prime trabalha com técnicas minimamente invasivas, voltadas à recuperação acelerada. O desconforto pós-operatório é acompanhado pela equipe.',
  },
  {
    question: 'Quem pode fazer implante dentário?',
    answer:
      'Em geral, adultos que perderam um ou mais dentes e têm saúde bucal adequada. Cada caso depende de exames de imagem, por isso a indicação só é confirmada na avaliação com a especialista.',
  },
  {
    question: 'Quais exames são feitos antes do implante?',
    answer:
      'Avaliação clínica, RX panorâmico e escaneamento 3D, todos realizados na própria COI Prime, no Bethaville. Eles permitem o planejamento digital da cirurgia.',
  },
  {
    question: 'A COI Prime tem segurança para cirurgias de implante?',
    answer:
      'Sim. A clínica conta com biossegurança de nível hospitalar, centro de esterilização, protocolos rigorosos de controle de infecção e salas climatizadas.',
  },
  {
    question: 'A COI Prime atende convênios e planos de saúde?',
    answer:
      'Não. A COI Prime não atende convênios nem planos de saúde. O atendimento é particular, com avaliação e planejamento individual.',
  },
  {
    question: 'Qual o endereço e o telefone da COI Prime para implantes?',
    answer: `A COI Prime fica na ${STREET_ADDRESS}, Barueri - SP, CEP ${POSTAL_CODE}. Telefone e WhatsApp: ${PHONE_LABEL}.`,
  },
];

const schemaMarkup = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': ['Dentist', 'MedicalClinic', 'LocalBusiness'],
      '@id': BUSINESS_ID,
      name: 'COI Prime Odontologia',
      alternateName: 'COI Prime',
      url: SITE_URL,
      description: PAGE_DESCRIPTION,
      address: {
        '@type': 'PostalAddress',
        streetAddress: STREET_ADDRESS,
        addressLocality: 'Barueri',
        addressRegion: 'SP',
        postalCode: POSTAL_CODE,
        addressCountry: 'BR',
      },
      telephone: PHONE_E164,
      email: 'contato@coiprime.com.br',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: PHONE_E164,
        contactType: 'customer service',
        areaServed: 'BR',
        availableLanguage: 'pt-BR',
      },
      priceRange: '$$',
      hasMap: MAPS_LINK,
      sameAs: [
        'https://www.instagram.com/coiprime/',
        'https://www.facebook.com/coi.prime',
      ],
      areaServed: [
        { '@type': 'City', name: 'Barueri' },
        { '@type': 'Place', name: 'Bethaville, Barueri - SP' },
      ],
      medicalSpecialty: 'Dentistry',
      knowsAbout: [
        'Implantodontia',
        'Implante dentário',
        'Prótese sobre implante',
        'Planejamento digital 3D',
      ],
      employee: {
        '@type': 'Person',
        name: 'Dra. Ivani',
        jobTitle: 'Especialista em Implantodontia',
        identifier: 'CROSP 66115',
        worksFor: { '@id': BUSINESS_ID },
      },
    },
    {
      '@type': 'Service',
      '@id': `${PAGE_URL}#service`,
      name: 'Implantes Dentários em Bethaville, Barueri',
      serviceType: 'Implantodontia',
      description:
        'Implante dentário com avaliação por RX panorâmico e escaneamento 3D, planejamento digital, cirurgia, prótese e acompanhamento pós-cirúrgico.',
      provider: { '@id': BUSINESS_ID },
      areaServed: [
        { '@type': 'City', name: 'Barueri' },
        { '@type': 'Place', name: 'Bethaville, Barueri - SP' },
      ],
    },
    {
      '@type': 'WebPage',
      '@id': `${PAGE_URL}#webpage`,
      url: PAGE_URL,
      name: PAGE_TITLE,
      description: PAGE_DESCRIPTION,
      inLanguage: 'pt-BR',
      about: { '@id': `${PAGE_URL}#service` },
    },
    {
      '@type': 'FAQPage',
      '@id': `${PAGE_URL}#faq`,
      isPartOf: { '@id': `${PAGE_URL}#webpage` },
      mainEntity: FAQS.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    },
  ],
};

const Implants: React.FC = () => {
  const location = useLocation();
  const [whatsappMessage, setWhatsappMessage] = useState('');

  useEffect(() => {
    if (location.pathname.includes('rede-social')) {
      setWhatsappMessage(
        'Olá! Encontrei vocês nas redes sociais e estou interessado em marcar um horário.'
      );
    } else {
      setWhatsappMessage('Olá gostaria de agendar uma avaliação para implante');
    }
  }, [location.pathname]);

  return (
    <Container>
      <Helmet htmlAttributes={{ lang: 'pt-BR' }}>
        <title>{PAGE_TITLE}</title>
        <meta httpEquiv="Content-Type" content="text/html;charset=UTF-8" />
        <meta name="description" content={PAGE_DESCRIPTION} />
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-image-preview:large"
        />
        <meta name="geo.region" content="BR-SP" />
        <meta name="geo.placename" content="Bethaville, Barueri" />
        <link rel="canonical" href={PAGE_URL} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:site_name" content="COI Prime Odontologia" />
        <meta property="og:url" content={PAGE_URL} />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESCRIPTION} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={PAGE_DESCRIPTION} />
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>
      <Hero className="position-relative">
        <div className="container h-100 position-relative">
          <div className="row align-items-lg-center h-100">
            <div className="col-lg-7 order-1 order-lg-0 text-center text-lg-start">
              <h1 className="text-white fw-light d-flex flex-column h2 display-lg-4 display-xxl-3 text-center text-lg-start">
                {/* <span className="h3 h1-lg fw-medium">COI Prime</span> */}
                <br />
                Implantes Dentários em Bethaville, Barueri
              </h1>
              <p className="h5 h3-lg text-white text-center text-lg-start mt-5 mt-lg-0">
                Recupere seu sorriso com{' '}
                <span className="fw-semibold">
                  segurança, tecnologia 3D e experiência comprovada
                </span>
                . Especialistas em implante no Bethaville, na clínica COI Prime.
              </p>
              <div className="d-lg-flex flex-column align-items-start w-100 w-lg-75">
                <a
                  href={`https://api.whatsapp.com/send?phone=551141981987&text=${whatsappMessage}`}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="mt-5 btn btn-schedule rounded-pill text-white fs-5 fs-lg-4 fw-medium px-5 py-3"
                  title="Quero Avaliar Meu Caso Agora"
                >
                  Quero Avaliar Meu Caso Agora{' '}
                  <img src={whatsAppSVG} width={24} alt="whatsapp" />
                </a>
                <small className="d-block text-white mt-2 fs-6 w-100">
                  *Não atendemos convênios e Planos&nbsp;de&nbsp;Saúde
                </small>
              </div>
            </div>
            <div className="col-lg-5 align-self-start d-flex justify-content-center justify-content-lg-end pt-5 order-0 order-lg-1">
              <img src={logo} alt="logo" />
            </div>
          </div>
        </div>
        <div className="position-absolute d-none d-lg-flex dra-ivani">
          <img src={draIvani} alt="Dra. Ivani - CRO 66115" />
          <p>
            Dra Ivani
            <br />
            CRO 66115
          </p>
        </div>
      </Hero>
      <Services>
        <div className="container">
          <div className="row py-5 px-3 px-lg-0">
            <div className="col-12 bg-gray px-3 py-5 px-lg-5">
              <div className="row justify-content-between align-items-center px-3 px-lg-5">
                <div className="col-7 col-lg-6 col-xl-7">
                  <h2 className="fs-2 fs-lg-1 fw-medium mb-5">
                    Especialistas em Implante no Bethaville: Mais de 30 Anos
                    Devolvendo Sorrisos em Barueri
                  </h2>
                </div>
                <div className="col-5 col-lg-5 mt-n5 mt-lg-0">
                  <img
                    src={stamp}
                    alt="A clínica mais tecnológica de Barueri"
                    className="d-block ms-auto stamp mt-lg-0 mt-xl-n4 w-100 w-lg-50 w-xl-auto"
                  />
                </div>
                <div className="col-lg-10 mt-4 mt-xl-n4">
                  <p className="fw-light fs-lg-5 text-black mb-5">
                    Na COI Prime, clínica odontológica no Bethaville, em
                    Barueri, a Dra. Ivani dedica a carreira à implantodontia há
                    mais de 30 anos. É referência em implantes de alta precisão,
                    atuando com técnicas minimamente invasivas, recuperação do
                    sorriso com tecnologia 3D e foco na naturalidade dos
                    resultados. Sua paixão está em devolver autoestima e
                    bem-estar para quem já perdeu dentes e sorrisos.
                  </p>
                </div>
                <div className="col-lg-10 mt-4 mt-xl-n4">
                  <p className="fs-lg-5 text-black">
                    <i>
                      “Cada implante é mais do que um dente. É a volta do prazer
                      em sorrir, mastigar e viver plenamente.”
                    </i>
                    <br />
                    <span> — Dra. Ivani</span>
                  </p>
                </div>
                <div className="align-self-start d-flex justify-content-between px-3 px-lg-5">
                  <DrIvaniHero>
                    <img
                      className="w-100 col-sm-8 front-mobile front-sm d-none d-sm-block px-4"
                      src={draIvaniHero}
                      alt="Dra. Ivani"
                    />
                    <img
                      className="w-100 front-mobile d-block d-sm-none mb-4"
                      src={draIvaniHero}
                      alt="Dra. Ivani"
                    />
                  </DrIvaniHero>
                  <p className="col-sm-4 my-auto front-mobile front-sm d-none d-sm-block">
                    <span className="h4">📍CROSP: 66115</span>
                    <br />
                    <span className="h5">- Especialista em Implantodontia</span>
                    <br />
                    <span className="h5">
                      - Especialista em Cirurgia Oral menor
                    </span>
                    <br />
                    <span className="h5">- Especialista em Ortodontia</span>
                    <br />
                    <span className="h5">
                      - Especialista em Harmonização Orofacial
                    </span>
                  </p>
                </div>
                <br />
              </div>
              <div className="row">
                <p className="w-100 front-mobile d-block d-sm-none">
                  <span className="h5">📍 CROSP: 66115</span>
                  <br />
                  <span className="h6">- Especialista em Implantodontia</span>
                  <br />
                  <span className="h6">
                    - Especialista em Cirurgia Oral menor
                  </span>
                  <br />
                  <span className="h6">- Especialista em Ortodontia</span>
                  <br />
                  <span className="h6">
                    - Especialista em Harmonização Orofacial
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </Services>
      <SpeedConsultation>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="bg-gray">
                {/* <p>Agilidade em sua Consulta</p> */}
                <h2 className="h5 h3-lg">
                  {/* Atendimento Prime com <b>alta tecnologia</b> para{' '}
                  <br className="d-none d-lg-block" />
                  cuidar da saúde dos seus dentes com qualidade */}
                  Estrutura Prime no Bethaville com Segurança de Nível
                  Hospitalar para Implantes
                </h2>
                <p className="fw-light mb-4">
                  A Coi Prime é a{' '}
                  <span>
                    <b>única clínica odontológica de Barueri</b>
                  </span>{' '}
                  equipada com{' '}
                  <span>
                    <b>biossegurança hospitalar</b>
                  </span>
                  , protocolos rígidos de esterilização e salas climatizadas.
                  Isso garante que seu tratamento seja feito com total
                  segurança, controle de infecção e tranquilidade –
                  especialmente para pacientes acima de 40 anos que priorizam
                  saúde em primeiro lugar.
                </p>
                <p className="fw-light mb-0">
                  Descubra por que somos a escolha número um para transformar
                  sorrisos na região!
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3 d-flex flex-column align-items-center techs">
              <img src={xRay} alt="Raio X panorâmico" />
              <p className="mb-5 mb-lg-0 mt-3 mt-lg-4 text-center">
                Raio X <br />
                panorâmico
              </p>
            </div>
            <div className="col-6 col-md-3 d-flex flex-column align-items-center techs">
              <img src={sterilizationCenter} alt="Centro de esterilização" />
              <p className="mb-5 mb-lg-0 mt-3 mt-lg-4 text-center">
                Centro de <br />
                esterilização
              </p>
            </div>
            <div className="col-6 col-md-3 d-flex flex-column align-items-center techs">
              <img
                src={technologicalTreatments}
                alt="Tratamentos Tecnologicos"
              />
              <p className="mb-0 mt-3 mt-lg-4 text-center">
                Tratamentos <br />
                Tecnologicos
              </p>
            </div>
            <div className="col-6 col-md-3 d-flex flex-column align-items-center techs">
              <img
                src={personalizedTreatments}
                alt="Tratamentos personalizados"
              />
              <p className="mb-0 mt-3 mt-lg-4 text-center">
                Tratamentos <br />
                personalizados
              </p>
            </div>
          </div>
        </div>
      </SpeedConsultation>
      <Services>
        <div className="container">
          <div className="row py-5 px-3 px-lg-0">
            <div className="col-12 bg-gray px-3 py-5 px-lg-5">
              <div className="row justify-content-between align-items-center px-xl-1 px-md-0 px-sm-0  px-lg-5">
                <div className="col-12 col-lg-12 col-xl-12">
                  <h2 className="fs-2 fs-lg-1 fw-medium mb-5">
                    Resultado real de implante dentário tratado na COI Prime, em
                    Barueri.
                  </h2>
                </div>
                <div className="align-self-start col-12 d-flex justify-content-between px-3 px-lg-5 front-mobile front-sm d-none d-sm-block">
                  <div className="col-lg-6 col-xl-6 col-sm-7 front-mobile front-sm d-none d-sm-block">
                    <InstagramPost
                      linkStr="https://www.instagram.com/reel/DG04f3jJENN/?igsh=MTE3YmV4enFqZ2RyMg=="
                      captioned={false}
                    />
                  </div>
                  <div className="col-lg-6 col-xl-5 col-sm-6 front-mobile front-sm d-none d-sm-block">
                    <p className="fw-light h3 pt-5 px-5">
                      Dona Valdeni, paciente da Dra. Ivani, compartilha como
                      voltou a sorrir, comer e se sentir bem após anos
                      convivendo com próteses desconfortáveis.
                    </p>
                  </div>
                </div>
                <div className="row w-100 front-mobile d-block d-sm-none">
                  <div className="w-100 front-mobile d-block d-sm-none">
                    <InstagramPost
                      width="95dvw"
                      linkStr="https://www.instagram.com/reel/DG04f3jJENN/?igsh=MTE3YmV4enFqZ2RyMg=="
                      captioned={false}
                    />
                  </div>
                  <div className="w-100 front-mobile d-block d-sm-none">
                    <p className="fw-light h4 pt-5">
                      Dona Valdeni, paciente da Dra. Ivani, compartilha como
                      voltou a sorrir, comer e se sentir bem após anos
                      convivendo com próteses desconfortáveis.
                    </p>
                  </div>
                </div>
                <br />
                <div className="row mt-5">
                  <div className="col-lg-6 col-sm-12 front-mobile front-sm d-none d-sm-block">
                    <InstagramPost linkStr="https://www.instagram.com/p/DGjC2OypEsE/" />
                  </div>
                  <div className="w-100 front-mobile d-block d-sm-none">
                    <InstagramPost
                      width="95dvw"
                      linkStr="https://www.instagram.com/p/DGjC2OypEsE/"
                    />
                  </div>
                  <div className="col-lg-6 col-sm-12 front-mobile front-sm d-none d-sm-block">
                    <InstagramPost linkStr="https://www.instagram.com/p/DIuJmfGpwX8/" />
                  </div>
                  <div className="w-100 front-mobile d-block d-sm-none">
                    <InstagramPost
                      width="95dvw"
                      linkStr="https://www.instagram.com/p/DIuJmfGpwX8/"
                    />
                  </div>
                </div>
                <br />
              </div>
            </div>
          </div>
        </div>
      </Services>
      <SpecialTreatments>
        <div className="container py-5">
          <SliderSlick
            infinite
            arrows={false}
            centerPadding="0px"
            autoplay
            autoplaySpeed={40000}
            dots
            adaptiveHeight
          >
            <div className="px-3">
              <div className="row bg-gray my-5">
                <div className="col-lg-5 px-0">
                  <img
                    src={coiExpirience}
                    alt="Cinco doutores reunidos, analisando minuciosamente um raio X panorâmico e discutindo estratégias de tratamento para o paciente."
                    className="w-100 d-none d-xl-block"
                  />
                  <img
                    src={coiExpirienceLaptop}
                    alt="Cinco doutores reunidos, analisando minuciosamente um raio X panorâmico e discutindo estratégias de tratamento para o paciente."
                    className="w-100 d-none d-lg-block d-xl-none"
                  />
                  <img
                    src={coiExpirienceMobile}
                    alt="Cinco doutores reunidos, analisando minuciosamente um raio X panorâmico e discutindo estratégias de tratamento para o paciente."
                    className="w-100 d-lg-none"
                  />
                </div>
                <div className="col-lg-7 px-3 py-5 px-lg-5 d-flex flex-column justify-content-between">
                  <div>
                    <h2 className="h3 fw-medium text-white">
                      Equipe completa que discutem cada caso e decidem juntos o
                      melhor tratamento para nossos pacientes
                    </h2>
                  </div>
                  <div className="pe-lg-5 mt-4 mt-lg-0">
                    <p className="text-white mb-4">
                      Cada pessoa é única. E assim deve ser a avaliação da sua
                      saúde bucal.
                    </p>
                    <p className="text-white mb-4">
                      Na COI Experience, otimizamos seu tempo com procedimentos
                      ágeis e especializados, proporcionando resultados eficazes
                      em um único dia.
                    </p>
                    <p className="text-white mb-4">
                      Confie em uma equipe com vasta experiência. Nossos
                      profissionais, com mais de 20 anos de prática, estão
                      comprometidos em oferecer tratamentos seguros e
                      personalizados.
                    </p>
                    <p className="text-white">
                      A COI Experience é um Dayclinic completo e personalizado
                      para quem quer o máximo de precisão, em linha com as
                      melhores práticas.
                    </p>
                  </div>
                  <div className="d-lg-flex flex-column align-items-center w-100 w-lg-75">
                    <a
                      href={`https://api.whatsapp.com/send?phone=551141981987&text=${whatsappMessage}`}
                      rel="noopener noreferrer"
                      target="_blank"
                      className="btn btn-primary rounded-pill py-3 fs-lg-5 fw-medium w-100 mt-4 mt-xl-0"
                      title="Agende já sua consulta particular"
                    >
                      Agende já sua consulta particular
                    </a>
                    <small className="d-block text-white mt-2 fs-6 text-center w-100">
                      *Não atendemos convênios e Planos&nbsp;de&nbsp;Saúde
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <div className="px-3">
              <div className="row bg-gray my-5">
                <div className="col-lg-5 px-0">
                  <img
                    src={checkUp}
                    alt="Doutora Ivani usando uma camera intra oral no paciente mostrando a ele em tempo real como estão seus dentes e falando o que se deve ou não fazer."
                    className="w-100 d-none d-xl-block"
                  />
                  <img
                    src={checkUpLaptop}
                    alt="Doutora Ivani usando uma camera intra oral no paciente mostrando a ele em tempo real como estão seus dentes e falando o que se deve ou não fazer."
                    className="w-100 d-none d-lg-block d-xl-none"
                  />
                  <img
                    src={checkUpMobile}
                    alt="Doutora Ivani usando uma camera intra oral no paciente mostrando a ele em tempo real como estão seus dentes e falando o que se deve ou não fazer."
                    className="w-100 d-lg-none"
                  />
                </div>
                <div className="col-lg-7 px-3 py-5 px-lg-5 d-flex flex-column justify-content-between">
                  <h2 className="fs-4 fs-lg-1 fw-medium text-white">
                    Implante Dentário no Bethaville: da Avaliação à Colocação
                    com Planejamento Digital 3D
                  </h2>
                  <div className="pe-lg-5 mt-4 mt-xl-0">
                    <p className="text-white mb-4 mt-n3">
                      <b className="d-lg-block d-xl-inline">Passo a passo:</b>
                    </p>
                    <ul className="ps-lg-5 ms-lg-3 mb-5">
                      <li className="text-light">
                        <p className="mb-0">
                          1 Avaliação com RX panorâmico e escaneamento 3D
                        </p>
                      </li>
                      <li className="text-light">
                        <p className="mb-0">
                          2 Planejamento digital e alinhamento de todas as
                          etapas
                        </p>
                      </li>
                      <li className="text-light">
                        <p className="mb-0">
                          3 Cirurgia para instalação dos implantes
                        </p>
                      </li>
                      <li className="text-light">
                        <p className="mb-0">
                          4 Confecção e instalação da prótese estética e
                          funcional
                        </p>
                      </li>
                      <li className="text-light">
                        <p className="mb-0">
                          5 Acompanhamento pós-cirúrgico e suporte humanizado
                        </p>
                      </li>
                    </ul>
                  </div>
                  <div className="d-lg-flex flex-column align-items-center w-100 w-lg-75">
                    <a
                      href={`https://api.whatsapp.com/send?phone=551141981987&text=${whatsappMessage}`}
                      rel="noopener noreferrer"
                      target="_blank"
                      className="btn btn-primary rounded-pill py-3 fs-lg-5 fw-medium w-100 mt-4 mt-xl-0"
                      title="Agende já sua consulta particular"
                    >
                      Agende já sua consulta particular
                    </a>
                    <small className="d-block text-white mt-2 fs-6 text-center w-100">
                      *Não atendemos convênios e Planos&nbsp;de&nbsp;Saúde
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </SliderSlick>
        </div>
      </SpecialTreatments>
      <Services>
        <div className="container">
          <div className="row py-5 px-3 px-lg-0">
            <div className="col-12 bg-gray px-3 py-5 px-lg-5">
              <div className="px-lg-5">
                <h2 className="fs-2 fs-lg-1 fw-medium mb-5">
                  Dúvidas Diretas sobre Implante Dentário no Bethaville, Barueri
                </h2>
                {FAQS.map((faq) => (
                  <div key={faq.question} className="mb-4">
                    <h3 className="h5 fw-medium text-black">{faq.question}</h3>
                    <p className="fw-light fs-lg-5 text-black mb-0">
                      {faq.answer}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Services>
      <Testimonials>
        <div className="container py-5">
          <div className="row">
            <div className="col-12">
              <h2 className="h6 h5-lg fw-light mb-5">
                {/* Depoimentos Escritos e Notas Google <br /> */}
                <span className="h2 h1-lg fw-medium">
                  Pacientes Satisfeitos com Implantes no Bethaville, Sorrisos
                  Reais
                </span>
              </h2>
              <div>
                <Reviews />
              </div>
            </div>
          </div>
        </div>
      </Testimonials>
      <Location>
        <div className="container py-5 my-5">
          <div className="row">
            <div className="col-12">
              <div className="bg-gray-mobile">
                <div className="row justify-content-between align-items-center align-items-xxl-end">
                  <div className="col-lg-5 mb-5 mb-lg-0 pe-lg-0 position-relative">
                    <img
                      src={locationBig}
                      alt="A faixada da clínica a noite com uma luz azul e o letreiro onde está escrito COI Prime Odontologia aceso com uma luz branca"
                      className="w-100 w-md-75 w-lg-100 d-block d-lg-none d-xl-block mx-md-auto mx-lg-0"
                    />
                    <img
                      src={locationMobile}
                      alt="A faixada da clínica a noite com uma luz azul e o letreiro onde está escrito COI Prime Odontologia aceso com uma luz branca"
                      className="w-100 w-md-75 w-lg-100 d-none d-lg-block d-xl-none mx-md-auto mx-lg-0"
                    />
                    <div className="detail" />
                  </div>
                  <div className="col-lg-7 bg-gray">
                    <div>
                      <h3 className="h6 h5-lg fw-light text-black">
                        LOCALIZAÇÃO
                      </h3>
                      <h2 className="h2 h1-lg mb-5 text-black">
                        Conheça <br className="d-block d-lg-none" />
                        nossa clínica de implantes no Bethaville, Barueri
                      </h2>
                    </div>
                    <div className="d-flex align-items-lg-center mb-4">
                      <FiMapPin size={30} color="#BE7E38" />
                      <div className="ms-2">
                        <h3 className="fs-6 fw-normal mb-0">Endereço:</h3>
                        <address className="mb-0">
                          <strong>COI Prime Odontologia</strong>
                          <br />
                          Av. Trindade, 165 – Bethaville I, Barueri – SP,
                          06404-326
                          <br />
                          Tel.:{' '}
                          <a
                            href={`tel:${PHONE_E164}`}
                            title={`Telefone: ${PHONE_LABEL}`}
                          >
                            {PHONE_LABEL}
                          </a>
                        </address>
                      </div>
                    </div>
                    <ul className="ps-lg-5 ms-lg-3 mb-5">
                      <li className="text-secondary">
                        <p className="mb-0">Fácil Acesso em Barueri</p>
                      </li>
                      <li className="text-secondary">
                        <p className="mb-0">
                          A 5 minutos da estação de trem e terminal de ônibus
                        </p>
                      </li>
                      <li className="text-secondary">
                        <p className="mb-0">Estacionamento gratuito no local</p>
                      </li>
                      <li className="text-secondary">
                        <p className="mb-0">
                          Clínica térrea com acessibilidade para PCDs
                        </p>
                      </li>
                    </ul>
                    {/* <a
                      href="https://maps.app.goo.gl/LPv5rTrzvAVKhsVSA"
                      rel="noopener noreferrer"
                      target="_blank"
                      className="btn btn-black rounded-pill px-4 py-2 fw-medium ms-2 ms-lg-0"
                      title="Ver rotas"
                    >
                      Ver rotas{' '}
                      <TbArrowUpRight size={24} color="#fff" className="ms-2" />
                    </a> */}
                  </div>
                </div>
                <div className="row justify-content-between align-items-center mt-5">
                  <iframe
                    title="Mapa da COI Prime Odontologia no Bethaville, Barueri"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3658.724568093344!2d-46.87191932461697!3d-23.50642827883757!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cf03a366ebf507%3A0x49c36685e3138fee!2sCOI%20Prime%20Odontologia%20-%20Cl%C3%ADnica%20Odontol%C3%B3gica%20em%20Barueri%20-%20Dentista%20em%20Barueri!5e0!3m2!1spt-BR!2sbr!4v1750097120916!5m2!1spt-BR!2sbr"
                    width="600"
                    height="450"
                    referrerPolicy="no-referrer-when-downgrade"
                    // style="border:0;"
                    // allowfullscreen=""
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Location>
      <Hero className="position-relative">
        <div className="container h-100 position-relative">
          <div className="row align-items-lg-center h-100">
            <div className="col-lg-7 order-1 order-lg-0 text-center text-lg-start">
              <h2 className="text-white fw-light d-flex flex-column h2 display-lg-4 display-xxl-3 text-center text-lg-start">
                {/* <span className="h3 h1-lg fw-medium">COI Prime</span> */}
                <br />
                Implante Dentário em Bethaville, Barueri: Faça Sua Avaliação
                Agora Mesmo
              </h2>
              <p className="h5 h3-lg text-white text-center text-lg-start mt-5 mt-lg-0">
                Atendimento humanizado, tecnologia de ponta e uma especialista
                em implantes dentários no Bethaville com mais de 30 anos de
                experiência. Agende sua avaliação e descubra como podemos
                transformar seu sorriso.
              </p>
              <div className="d-lg-flex flex-column align-items-start w-100 w-lg-75">
                <a
                  href={`https://api.whatsapp.com/send?phone=551141981987&text=${whatsappMessage}`}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="mt-5 btn btn-schedule rounded-pill text-white fs-5 fs-lg-4 fw-medium px-5 py-3"
                  title="Quero Avaliar Meu Caso Agora"
                >
                  Quero Avaliar Meu Caso Agora{' '}
                  <img src={whatsAppSVG} width={24} alt="whatsapp" />
                </a>
                <small className="d-block text-white mt-2 fs-6 w-100">
                  *Não atendemos convênios e Planos&nbsp;de&nbsp;Saúde
                </small>
              </div>
            </div>
          </div>
        </div>
      </Hero>
    </Container>
  );
};

export default Implants;
